import { axios, BaseApiUrl } from '../axios_config';

// 获取托唛数据
export const getDeliveryPallet = params =>{
    return axios.get(`${BaseApiUrl}/TFMobile/GetDeliveryPallet`, { params }).then(res => res.data);
}
// 提交换库位操作
export const deliveryPalletInventory = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/DeliveryPalletInventory`, { ...params }).then(res => res.data);
}
// 列表
export const getPalletInventoryList = params => {
    return axios.post(`${BaseApiUrl}/TFMobile/GetPalletInventoryList`, { ...params }).then(res => res.data)
}
